import { useEffect, useCallback } from 'react';

export default function useDidMount(callback = () => {}) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const stableCallback = useCallback(callback, []);

  useEffect(() => {
    const unsubscribeFn = stableCallback();

    return typeof unsubscribeFn === 'function' ? unsubscribeFn : () => {};
  }, [stableCallback]);
}
